import React from 'react';
// 1. Import `useLocation` from react-router-dom
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  // 2. Get the user's current location
  const location = useLocation();

  return currentUser ? (
    children
  ) : (
    // 3. Pass the location in state and add the `replace` prop
    <Navigate to="/login" state={{ from: location }} replace />
  );
}

export default PrivateRoute;